module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-h"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('b', [_vm._v("CONTENTS")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/08_Introduction"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_Part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("EUROPE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/10_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Prehistoric Cosmonauts ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("VAL CAMONICA, ITALY")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Vitrified Fort of Craig Phadrig ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("INVERNESS, SCOTLAND")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Glass Tower of the Fomorians ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORY ISLAND, IRELAND")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Amphitheater of Light ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEIPZIG, GERMANY")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Celestial Cross of Migné ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MIGNÉ-AUXANCES, FRANCE")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Apparitions of Fátima ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("FÁTIMA, PORTUGAL")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Call of the Xipéhuz ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("LONDON, UNITED KINGDOM")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Martian Language School ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("GENEVA, SWITZERLAND")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Capital of Marxist Ufology ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("BRUSSELS, BELGIUM")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Morsbach Flying Saucer ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOSELLE, FRANCE")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Star of Marliens ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("CÔTE-D’OR, FRANCE")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Chabeuil Double ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("DRÔME, FRANCE")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The UFO Port of Arès ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("GIRONDE, FRANCE")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Ummite HQ ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOSCOW, RUSSIA")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("AFRICA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Children of Sirius ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("BANDIAGARA ESCARPMENT, MALI")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Flying Cigar of Tananarive ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANTANANARIVO, MADAGASCAR")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("ASIA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Lost Tribes from Outer Space ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("CANAAN, ISRAEL")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Ogdy’s Wrath ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUNGUSKA, SIBERIA")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Intraterrestrial Portal ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGARTHA, MONGOLIA")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Supercivilizations Observatory ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("BYURAKAN, ARMENIA")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Spied-On Cosmodrome ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("BAIKONUR, KAZAKHSTAN")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/33_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("THE AMERICAS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/34_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Pre-Columbian Lines ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NAZCA, PERU")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/35_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Astral Church ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("BRYN ATHYN, PENNSYLVANIA, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/36_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The International Fortean Organization ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANOVER, MARYLAND, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/37_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The First Flying Saucers ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOUNT RAINIER, WASHINGTON, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/38_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Two Crash Sites ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSWELL, NEW MEXICO, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/39_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Abduction of Barney and Betty Hill ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("FRANCONIA, NEW HAMPSHIRE, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/40_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The UFO Island ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRINDADE, BRAZIL")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/41_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Wounded Devil ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("VARGINHA, BRAZIL")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/42_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Welcome to Dreamland ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEVADA, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/43_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The SETI Institute ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOUNTAIN VIEW, CALIFORNIA, UNITED STATES")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/44_Part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("OCEANIA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/45_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Lost City of the Pacific ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("POHNPEI, MICRONESIA")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/46_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Hot Waves ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("PARKES, AUSTRALIA")]), _vm._v(")")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/47_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("ELSEWHERE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/48_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_c('b', [_vm._v("UFO GLOSSARY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fig-img"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/009_001.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4c57368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Contents.vue
// module id = 72
// module chunks = 0